<div class="modificators-title">
  {{ modificators && modificators.active ? (modificators | titleTranslate) : ('add' | translate) }}
</div>
<!-- Аллергены, которые есть у добавок группы -->
<app-allergen-list variant="addons" title="allergensInAddons" [allergens]="addonsAllergens"></app-allergen-list>
<div class="modificators-grid">
  <app-menu-modificator-card
    *ngFor="let modificator of modificators?.items"
    [modificator]="modificator"
    [width]="width"
    [height]="height"
    [locale]="locale"
    (increment)="onModificatorIncrement($event)"
    (decrement)="onModificatorDecrement($event)"
    (toggle)="onModificatorClick($event)">
  </app-menu-modificator-card>
</div>